import { useEffect, useState } from 'react'

export default function NapraviSam() {

  useEffect(() => {
    console.log('testttt')
  })

  const [isPhotoChecked, setIsPhotoChecked] = useState(false);
  const [isVideoChecked, setIsVideoChecked] = useState(false);

  const [selectionObject, setSelectionObject] = useState({
    photo: {
      dogadjajPhoto: '',
      fotograf: '',
      reportazni: '',
      prewedding: '',
      kopija: '',
      kutija: '',
      book: '',
      slikaNaPlatnu: '',
      album: ''
    },
    video: {
      dogadjajVideo: '',
      snimatelj: '',
      log: '',
      dron: '',
      kopija: '',
      kutija: '',
      rezolucija: ''
    }
  })

  const handleSelect = (e) => {
    const id = e.target?.id;
    const value = e.target.value;
    
    if(id === 'dogadjajPhoto') {
      setSelectionObject(prev => {
        prev.photo[id] = value;
        return prev; 
      })
    } 
    
    if (id === 'dogadjajVideo') {
      setSelectionObject(prev => {
        prev.video[id] = value;
        return prev;
      })
    } 
  }


  return (
    <>
      <div className='flex flex-col lg:flex-row justify-center items-center gap-10'>
        <div className="w-64 flex flex-col gap-2">
          <div className='flex gap-4 justify-center items-center'>
            <input
              type="checkbox"
              id="checkbox"
              checked={isPhotoChecked}
              onChange={() => setIsPhotoChecked(prev => !prev)}
              className="w-4 h-4 text-indigo-600 bg-gray-100 border-gray-300 rounded focus:ring-indigo-500"
            />
            <h1 className='text-black text-3xl mb-2'>Photo</h1>
          </div>

          <div className='flex flex-col gap-2'>
            <select
              id="dogadjajPhoto"
              defaultValue={selectionObject.photo.dogadjajPhoto}
              onChange={handleSelect}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
              disabled={!isPhotoChecked}
              
            >
              <option value="" disabled>
                Izaberi dogadjaj
              </option>
              <option value="vencanje" >Vencanje</option>
              <option value="krstenje">Krstenje</option>
              <option value="punoletstvo">Punoletstvo</option>
            </select>

            <select
              id="fotograf"
              defaultValue={selectionObject.photo.fotograf}
              onChange={handleSelect}
              disabled={!isPhotoChecked || !selectionObject.photo.dogadjajPhoto}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Broj fotografa
              </option>
              <option value="jedan" >Jedan</option>
              <option value="dva">Dva</option>
            </select>

            <select
              id="reportazni"
              defaultValue={selectionObject.photo.reportazni}
              onChange={handleSelect}
              disabled={!isPhotoChecked || !selectionObject.photo.dogadjajPhoto}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Reportažni fotograf
              </option>
              <option value="da" >Da</option>
              <option value="ne">Ne</option>
            </select>

            <select
              id="prewedding"
              defaultValue={selectionObject.photo.prewedding}
              onChange={handleSelect}
              disabled={!isPhotoChecked || !selectionObject.photo.dogadjajPhoto}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Prewedding
              </option>
              <option value="da" >Da</option>
              <option value="ne">Ne</option>
            </select>

            <select
              id="kopija"
              defaultValue={selectionObject.photo.kopija}
              onChange={handleSelect}
              disabled={!isPhotoChecked || !selectionObject.photo.dogadjajPhoto}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Broj kopija
              </option>
              <option value="jedna" >Jedna</option>
              <option value="dve">Dve</option>
              <option value="tri">Tri</option>
              <option value="cetiri">Cetiri</option>
            </select>

            <select
              id="kutija"
              defaultValue={selectionObject.photo.kutija}
              onChange={handleSelect}
              disabled={!isPhotoChecked || !selectionObject.photo.dogadjajPhoto}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Kutija za flash
              </option>
              <option value="da" >Da</option>
              <option value="ne">Ne</option>
            </select>

            <select
              id="book"
              defaultValue={selectionObject.photo.book}
              onChange={handleSelect}
              disabled={!isPhotoChecked || !selectionObject.photo.dogadjajPhoto}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Book
              </option>
              <option value="ne" >Ne</option>
              <option value="small">15x20cm</option>
              <option value="medium">20x30cm</option>
              <option value="big">30x30cm</option>
              <option value="large">30x40cm</option>
            </select>

            <select
              id="slikaNaPlatnu"
              defaultValue={selectionObject.photo.slikaNaPlatnu}
              onChange={handleSelect}
              disabled={!isPhotoChecked || !selectionObject.photo.dogadjajPhoto}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Slika na platnu
              </option>
              <option value="ne" >Ne</option>
              <option value="small">40x60cm</option>
              <option value="medium">60x90cm</option>
              <option value="large">100x150cm</option>
            </select>

            <select
              id="album"
              defaultValue={selectionObject.photo.album}
              onChange={handleSelect}
              disabled={!isPhotoChecked || !selectionObject.photo.dogadjajPhoto}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Album sa fotografijama
              </option>
              <option value="ne" >Ne</option>
              <option value="small">100 fotografija</option>
              <option value="medium">200 fotografija</option>
              <option value="large">300 fotografija</option>
            </select>
          </div>

          <h1 className='text-black text-2xl'>Cena za photo: 500e</h1>
        </div>

        {/* 
   ---------------------------------------------------
   ------------------ VIDEO --------------------------
   --------------------------------------------------- 
   */}

        <div className="w-64  flex flex-col gap-2">
          <div className='flex gap-4 justify-center items-center'>
            <input
              type="checkbox"
              id="checkbox"
              checked={isVideoChecked}
              onChange={() => setIsVideoChecked(prev => !prev)}
              className="w-4 h-4 text-indigo-600 bg-gray-100 border-gray-300 rounded focus:ring-indigo-500"
            />
            <h1 className='text-black text-3xl mb-2'>Video</h1>
          </div>

          <div className='flex flex-col gap-2'>
            <select
              id="dogadjajVideo"
              defaultValue={selectionObject.video.dogadjajVideo}
              onChange={handleSelect}
              disabled={!isVideoChecked}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Izaberi dogadjaj
              </option>
              <option value="vencanje" >Vencanje</option>
              <option value="krstenje">Krstenje</option>
              <option value="punoletstvo">Punoletstvo</option>
            </select>

            <select
              id="snimatelj"
              defaultValue={selectionObject.video.snimatelj}
              onChange={handleSelect}
              disabled={!isVideoChecked || !selectionObject.video.dogadjajVideo}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Broj snimatelja
              </option>
              <option value="jedan" >Jedan</option>
              <option value="dva">Dva</option>
            </select>

            <select
              id="log"
              defaultValue={selectionObject.video.log}
              onChange={handleSelect}
              disabled={!isVideoChecked || !selectionObject.video.dogadjajVideo}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Snimanje u Log-u
              </option>
              <option value="da" >Da</option>
              <option value="ne">Ne</option>
            </select>

            <select
              id="dron"  
              defaultValue={selectionObject.video.dron}
              onChange={handleSelect}
              disabled={!isVideoChecked || !selectionObject.video.dogadjajVideo}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Dron
              </option>
              <option value="da" >Da</option>
              <option value="ne">Ne</option>
            </select>

            <select
              id="kopija"
              defaultValue={selectionObject.video.kopija}
              onChange={handleSelect}
              disabled={!isVideoChecked || !selectionObject.video.dogadjajVideo}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Broj kopija
              </option>
              <option value="jedna" >Jedna</option>
              <option value="dve">Dve</option>
              <option value="tri">Tri</option>
              <option value="cetiri">Cetiri</option>
            </select>

            <select
              id="kutija"
              defaultValue={selectionObject.video.kutija}
              onChange={handleSelect}
              disabled={!isVideoChecked || !selectionObject.video.dogadjajVideo}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Kutija za flash
              </option>
              <option value="da" >Da</option>
              <option value="ne">Ne</option>
            </select>

            <select
              id="rezolucija"
              defaultValue={selectionObject.video.rezolucija}
              onChange={handleSelect}
              disabled={!isVideoChecked || !selectionObject.video.dogadjajVideo}
              className="block w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black"
            >
              <option value="" disabled>
                Rezolucija
              </option>
              <option value="fullhd" >Full HD</option>
              <option value="4K">4K</option>
            </select>


            {/* ... UNUSED ... */}
            <select
              id="kvalitet"
              defaultValue={'a'}
              onChange={handleSelect}
              disabled={true}
              className="w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black hidden lg:invisible"
            >
              <option value="a">
                dummy1
              </option>
            </select>
            <select
              id="kvalitet"
              defaultValue={'b'}
              onChange={handleSelect}
              disabled={true}
              className="w-full p-2 border border-red-500 rounded-md shadow-sm focus:ring-red-500 focus:border-red-500 text-black hidden lg:invisible"
            >
              <option value="b">
                dummy2
              </option>
            </select>
            {/* ... UNUSED ... */}

          </div>
          <h1 className='text-black text-2xl'>Cena za video: 500e</h1>
        </div>
      </div>
      <h1 className='text-black mt-12 text-cardFont text-3xl'>Ukupna cena: <span className='text-red-600'>1000</span>e</h1>

    </>
  )
}
